// extracted by css-extract-rspack-plugin
export default {"wrapper":"GcWIo","width_expand":"bZ64S","widthExpand":"bZ64S","search_button_override":"KdYp7","searchButtonOverride":"KdYp7","#":"qvmGF"};